import React from 'react';
import { Form, Input, Select, Button, Row, Col } from 'antd';
import { ONBOARDING_CURRENCIES } from '../../../../../../Onboarding/onboardingConstants';

const FormItem = Form.Item;
const { Option } = Select;

function ManualAddUserForm({ form, loading, onAdd }) {
  const { getFieldDecorator } = form;

  const submit = (e) => {
    e.preventDefault();
    form.validateFields(async (err, fieldsValue) => {
      if (err) return;

      try {
        await onAdd({
          email: String(fieldsValue.email ?? '').trim(),
          firstName: String(fieldsValue.firstName ?? '').trim(),
          lastName: String(fieldsValue.lastName ?? '').trim(),
          fullBusinessName: String(fieldsValue.fullBusinessName ?? '').trim(),
          tradingName: String(fieldsValue.tradingName ?? '').trim(),
          registrationNumber: String(fieldsValue.registrationNumber ?? '').trim(),
          planName: String(fieldsValue.planName ?? '').trim(),
          currency: fieldsValue.currency,
        });
        form.resetFields();
      } catch {
        // error message handled by parent
      }
    });
  };

  return (
    <Form layout="vertical" className="add-users-manual-form">
      <FormItem label="Email">
        {getFieldDecorator('email', {
          validateTrigger: 'onBlur',
          rules: [
            { required: true, message: 'Please enter the user email.' },
            { type: 'email', message: 'Please enter a valid email.' },
          ],
        })(<Input placeholder="user@example.com" disabled={loading} spellCheck={false} />)}
      </FormItem>
      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <FormItem label="First name">
            {getFieldDecorator('firstName', {
              rules: [{ required: true, whitespace: true, message: 'Please enter the first name.' }],
            })(<Input disabled={loading} />)}
          </FormItem>
        </Col>
        <Col xs={24} sm={12}>
          <FormItem label="Last name">
            {getFieldDecorator('lastName', {
              rules: [{ required: true, whitespace: true, message: 'Please enter the last name.' }],
            })(<Input disabled={loading} />)}
          </FormItem>
        </Col>
      </Row>
      <FormItem label="Business name (optional)">
        {getFieldDecorator('fullBusinessName')(
          <Input placeholder="Legal registered name" disabled={loading} />,
        )}
      </FormItem>
      <FormItem label="Trading name (optional)">
        {getFieldDecorator('tradingName')(
          <Input placeholder="Name used day-to-day" disabled={loading} />,
        )}
      </FormItem>
      <FormItem label="Business reg. no. (optional)">
        {getFieldDecorator('registrationNumber')(
          <Input placeholder="ABN / ACN" disabled={loading} />,
        )}
      </FormItem>
      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <FormItem label="Plan name (optional)">
            {getFieldDecorator('planName')(<Input disabled={loading} />)}
          </FormItem>
        </Col>
        <Col xs={24} sm={12}>
          <FormItem label="Currency (optional)">
            {getFieldDecorator('currency')(
              <Select placeholder="Select currency" disabled={loading} allowClear>
                {ONBOARDING_CURRENCIES.map((currencyOption) => (
                  <Option key={currencyOption.value} value={currencyOption.value}>
                    {currencyOption.label}
                  </Option>
                ))}
              </Select>,
            )}
          </FormItem>
        </Col>
      </Row>
      <FormItem>
        <Button type="primary" block loading={loading} onClick={submit}>
          Add user
        </Button>
      </FormItem>
    </Form>
  );
}

export default Form.create()(ManualAddUserForm);
